import React from "react";
import styles from "./styles.module.scss";

interface Props {
  facilities: any[];
  onSelect: (facility: any) => void;
}

const FacilityList = ({ facilities, onSelect }: Props) => (
  <div className={styles.list}>
    {facilities.map((facility) => {
      const logo = facility.publicLogoUrl || facility.public_logo_url;
      return (
        <div
          key={facility.id}
          className={styles.list_row}
          onClick={() => onSelect(facility)}
        >
          {logo ? (
            <img
              src={logo}
              alt={facility.name}
              className={styles.facility_logo}
            />
          ) : (
            <div className={styles.facility_initials}>
              {facility.name?.charAt(0)?.toUpperCase()}
            </div>
          )}
          <span className={styles.list_row_name}>{facility.name}</span>
        </div>
      );
    })}
  </div>
);

export default FacilityList;
